module.exports = __webpack_public_path__ + "img/symbol_3.f5997bcc.png";